import api from "../apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    province() {
        return api.get(`/api/v1/province`);
    },

}